import { render, staticRenderFns } from "./AttendeeAdd.vue?vue&type=template&id=5c52a841&"
import script from "./AttendeeAdd.vue?vue&type=script&lang=js&"
export * from "./AttendeeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports